import { useState } from "react";
import { Download, Send } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

export const download = async (category) => {
  try {
    const res = await api.get("/admin/waitlist/export", { params: category ? { category } : {}, responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = Object.assign(document.createElement("a"), { href: url, download: `markhor-waitlist-${category ?? "all"}.csv` });
    a.click();
    URL.revokeObjectURL(url);
  } catch (e) {
    toast.error(apiError(e));
  }
};

export const CategoryRow = ({ c, onDone }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const launch = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/waitlist/${c.category}/launch`);
      if (data?.sent) toast.success(`Launch email sent to ${data.sent} ${data.sent === 1 ? "person" : "people"}${data.failed ? ` · ${data.failed} failed` : ""}`);
      else toast.message(data?.message ?? "No emails sent.");
      onDone();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
      setOpen(false);
    }
  };
  return (
    <tr className="border-b border-line align-middle" data-testid={`admin-row-${c.category}`}>
      <td className="py-5 pr-4"><p className="font-display text-xl text-ink">{c.title}</p><p className="text-xs text-graphite">Last signup: {fmt(c.latest_signup)}</p></td>
      <td className="py-5 pr-4 font-display text-3xl text-ink" data-testid={`admin-total-${c.category}`}>{c.total}</td>
      <td className="py-5 pr-4 text-sm text-graphite"><span className="text-ink">{c.pending}</span> waiting · {c.notified} emailed<br /><span className="text-xs">Last launch: {fmt(c.last_launch_at)}</span></td>
      <td className="py-5">
        <div className="flex flex-wrap justify-end gap-2">
          <button onClick={() => download(c.category)} className="btn-outline !px-4 !py-3" data-testid={`admin-export-${c.category}`}><Download className="h-3.5 w-3.5" />CSV</button>
          <button disabled={!c.pending || busy} onClick={() => setOpen(true)} className="btn-dark !px-4 !py-3" data-testid={`admin-launch-${c.category}`}><Send className="h-3.5 w-3.5" />{busy ? "Sending…" : "Send launch email"}</button>
        </div>
        <AlertDialog open={open} onOpenChange={setOpen}>
          <AlertDialogContent className="rounded-none border-line bg-ivory" data-testid={`admin-launch-confirm-${c.category}`}>
            <AlertDialogHeader>
              <AlertDialogTitle className="font-display text-3xl font-light">Send the {c.title} launch email?</AlertDialogTitle>
              <AlertDialogDescription>This emails {c.pending} {c.pending === 1 ? "person" : "people"} who joined this waitlist and haven't been emailed yet. Each person only ever receives it once.</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel className="rounded-none" data-testid="admin-launch-cancel">Cancel</AlertDialogCancel>
              <AlertDialogAction className="rounded-none bg-ink" onClick={launch} data-testid="admin-launch-confirm-button">Send now</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </td>
    </tr>
  );
};
